import { render, staticRenderFns } from "./HeaderControlsRelatedDeliverablesSocialCalendar.vue?vue&type=template&id=4e2f843e&"
import script from "./HeaderControlsRelatedDeliverablesSocialCalendar.vue?vue&type=script&lang=js&"
export * from "./HeaderControlsRelatedDeliverablesSocialCalendar.vue?vue&type=script&lang=js&"
import style0 from "./HeaderControlsRelatedDeliverablesSocialCalendar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/www/uat.mediaworkflow.winnipeg.ca/laravel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4e2f843e')) {
      api.createRecord('4e2f843e', component.options)
    } else {
      api.reload('4e2f843e', component.options)
    }
    module.hot.accept("./HeaderControlsRelatedDeliverablesSocialCalendar.vue?vue&type=template&id=4e2f843e&", function () {
      api.rerender('4e2f843e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/csmworkflow/js/components/common/HeaderControlsRelatedDeliverablesSocialCalendar.vue"
export default component.exports